import React, { useEffect, useRef, useState } from "react";
import CustomButton from "../../../ui/Button";
import LabelText from "../../../ui/LabelText";
import { StyledHeader } from "../../ClubDetail/ClubFinancial/ClubFinancial";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomizedTooltips from "../../../ui/Tooltip";
import Plus from "../../../assets/icons/Plus.png"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  fetchAfterSwapData,
  fetchChemistryData,
  fetchChemistrySummaryData,
  fetchFormationData,
  fetchIndividualChemistry,
  fetchMatchTimeline,
  fetchMatchTimelineZoomLevel2,
  fetchOverallFormationData,
  fetchPlayerCardData,
  fetchPredictiveChemistryConnection,
  fetchSeasonData,
  fetchSwapablePlayerData,
  handleSearch,
  ISynergyData,
} from "../../../pages/Chemistry/Utils";
import { useLoading } from "../../../contexts/LoadingContext";
import { ITeamMatchByMonths } from "../../../types/ITimeline";
import LabelNumber from "../../../styled-components/LabelNumber";
import Timeline, { SelectedData } from "../../Timeline";
import { ChemistryPlayerPositions, IOption, OtherSquadMembers, PlayerFromSamePositions } from "../../../types/IOption";
import Pitch from "../../Pitch";
import Switch from "../../../ui/CustomSwitch";
import { BackToTeamChemistryBtn } from "../../../pages/Chemistry/StyledChemistryElements";
import ResetIcon from "../../../assets/icons/Reset.png";
import Simulate from "../../../assets/icons/Simulate.png";
import { FormationSelectDrawer, PlayerSelectDrawer } from "../../../pages/Chemistry/UIContent";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useSearch } from "../../../contexts/PlayerSearchContext";
import { IPlayerSearchResponse } from "../../../types/IPlayerSearchResponse";
import SecondaryButton from "../../../ui/SecondaryButton";
import { ButtonKey } from "../../../pages/Chemistry";
import { IPlayerCardDetail } from "../../../types/IPlayerCardDetail";
import PlayerLandingCard from "../../../ui/CardComponent";
import PositiveArrow from "../../../assets/icons/PositiveArrow.png";
import NegativeArrow from "../../../assets/icons/NegativeArrow.png";
import { BothPlayerImageContainer, PlayerImageContainer } from "../../PlayerInfo";
import { useSquadSystemFitContext } from "../../../contexts/SquadSystemFitContext";
import { InfoOutlined } from "@mui/icons-material";
import PWNotification from "../../PWNotification";
import { useNotification } from "../../../contexts/NotificationContext";
import MachineFootballIcon from "../../../assets/sidebarIcons/MachineFootballIcon.png";
import { styled } from "@mui/material/styles";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { ModuleSpinner } from "../../../ui/LoadingSpinner/ModuleSpinner";
import TrackerIcon from "../../../assets/icons/Tracker.png";
import IApiResponse from "../../../types/IApiResponse";
import { postData } from "../../../services/api";
import apiUrls from "../../../config/apiUrls";
import handleApiResponse from "../../../utils/handleApiResponse";
interface SquadSystemFitPropsType {
  team: number;
  clubImg: string;
  isFromClub? : boolean
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[300],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#00D1A8",
    ...theme.applyStyles("dark", {
      backgroundColor: "#308fe8",
    }),
  },
}));

export const SquadSystemFit: React.FC<SquadSystemFitPropsType> = React.memo(({ team, clubImg , isFromClub}) => {
  let environment = process.env.REACT_APP_MODE??"";
  const {
    selectedTeam,
    setSelectedTeam,
    positionResults,
    setPositionResults,
    teamChemistry,
    setTeamChemistry,
    selectedSeasonId,
    setSelectedSeasonId,
    timeLineTag,
    setTimeLineTag,
    seasonName,
    setSeasonName,
    zoomLevelId,
    setZoomLevelId,
    formationData,
    setFormationData,
    selectedFormation,
    setSelectedFormation,
    isSwapActive,
    setIsSwapActive,
    isIndividualChemistry,
    setIsIndividualChemistry,
    lastPositionResults,
    setLastPositionResults,
    lastTeamChemistry,
    setLastTeamChemistry,
    swappedPlayerClub,
    setSwappedPlayerClub,
    otherClubPlayer,
    setOtherClubPlayer,
    playerToSwap,
    setPlayerToSwap,
    swappedPositionResults,
    setSwappedPositionResults,
    swappedTeamChemistry,
    setSwappedTeamChemistry,
    thirdOfSeason,
    setThirdOfSeason,
    overallSFScore,
    setOverallSFScore,
    newOverallSFScore,
    setNewOverallSFScore,
    avgAge,
    setAvgAge,
    newAvgAge,
    setNewAvgAge,
    attackContribution,
    setAttackContribution,
    newAttackContribution,
    setNewAttackContribution,
    currentPlayerView,
    setCurrentPlayerView,
    playerToSwapWith,
    setPlayerToSwapWith,
    leagueValues,
    setLeaguevalues,
    disabledButtons,
    setDisabledButtons,
    ppda,
    setPPDA,
    newPPDA,
    setNewPPDA,
    synergyData,
    setSynergyData,
    selectedByPlayerPair, setSelectedByPlayerPair,
    overallSystemFitScore , setOverAllSystemFitScore
  } = useSquadSystemFitContext();
  const { displayCardNotification, seIsDisplayCardNotification, cardNotificationContent, setCardNotificationContent } = useNotification();
  const { setSearchText, setSearchData, searchData, searchText } = useSearch();
  const [timeLineDrawerOpen, setTimeLineDrawerOpen] = useState<boolean>(false);
  const { loading, startLoading, stopLoading } = useLoading();
  const [matches, setMatches] = useState<any[]>([]);
  const [teamMatchesByMonth, setTeamMatchesByMonth] = useState<ITeamMatchByMonths[]>([]);
  const [sidebarFormationOpen, setSidebarFormationOpen] = useState<boolean>(false);
  const [isPerformancSwitchToggled, setIsPerformanceSwitchToggled] = useState<boolean>(false);
  const [isDisplayInitialRect, setIsDisplayInitialRect] = useState<boolean>(true);
  const [isChemistryDataNotEnough, setIsChemistryDataNotEnough] = useState<boolean>(false);
  const [swapHoverPlayer, setSwapHoverPlayer] = useState<number>(0);
  const [swapPositionCode, setSwapPositionCode] = useState<string>("");
  const [sidebarPlayerShow, setSidebarPlayerShow] = useState<boolean>(false);
  const [isReplacePlayer, setIsReplacePlayer] = useState<boolean>(false);
  const [playerCardID, setPlayerCardID] = useState<number>(0);
  const [seasonData, setSeasonData] = useState<IOption[]>([]);
  const [playerFromSamePositions, setPlayerFromSamePositions] = useState<PlayerFromSamePositions[]>([]);
  const [otherSquadMembers, setOtherSquadMembers] = useState<OtherSquadMembers[]>([]);
  const [playerCardDetails, setPlayerCardDeatils] = useState<IPlayerCardDetail | undefined>(undefined);
  const playerCardRef = useRef(null);
  const [isPPDATolltipOpen, setIsPPDATooltipOpen] = useState(false);
  const PPDATooltipRef = useRef<NodeJS.Timeout | null>(null);
  const [showLeftTooltip, setShowLeftTooltip] = useState(false);
  const [showRightTooltip, setShowRightTooltip] = useState(false);
  const leftTooltipTimeout = useRef<NodeJS.Timeout | null>(null);
  const rightTooltipTimeout = useRef<NodeJS.Timeout | null>(null);
  const [loadingProgressValue, setLoadingProgressValue] = useState<number>(0);
  const [isSystemfitLoading, setIsSystemfitLoading] = useState<boolean>(false);
  const [subProcessIndex, setSubProcessIndex] = useState<number>(0);
  const subProcesses = [
    "Retrieving team data and formation",
    "Calculating chemistry between players",
    "Fitting players into the formation",
    "Nearly complete",
  ];
  const [alreadyPlottedPlayer, setAlreadyPlottedPlayer] = useState<{ playerID: number; xPosition: number; yPosition: number }>({
    playerID: 0,
    xPosition: 0,
    yPosition: 0,
  });

    const nationalityTooltip = leagueValues?.coaches?.length! > 1 ? (
        <div>
          <ul style={{ margin: "0px", paddingLeft: "20px" }}>
            {leagueValues?.coaches?.map((coaches) => (
              <li key={coaches?.coachId!}>
                <div>
                  <LabelText className="tooltip-text">{coaches?.coachName!}</LabelText>
                  <LabelText className="tooltip-text">{` (matches : ${coaches?.coachedMatches!})`}</LabelText>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : null;

  const handleSwitchClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    event.stopPropagation();
    setIsPerformanceSwitchToggled((prev) => !prev);
  };

  const fetchMatchTimelineZoom2 = async (
    thirdOfSeason: string,
    isPrevious: boolean,
    isNext: boolean,
    newZoomLevel: number,
    team: number,
    seasonId?: number
  ) => {
    const currentSeasonId = seasonId ?? selectedSeasonId;
    await fetchMatchTimelineZoomLevel2(
      startLoading,
      team,
      setMatches,
      setDisabledButtons,
      setSelectedSeasonId,
      currentSeasonId,
      thirdOfSeason,
      isPrevious,
      isNext,
      newZoomLevel,
      setTimeLineTag,
      setSeasonName,
      async (updatedMatches, updatedSeasonId) => {
        const matchIds = updatedMatches.map((match) => match.matchId);
        const selectedFormationId = await fetchFormationData(
          team,
          updatedSeasonId,
          startLoading,
          stopLoading,
          setFormationData,
          setSelectedFormation,
          matchIds
        );
        if (selectedFormationId !== null) {
          await fetchChemistryData(
            team,
            updatedSeasonId,
            setPositionResults,
            setTeamChemistry,
            startLoading,
            stopLoading,
            selectedFormationId,
            setLastTeamChemistry,
            setLastPositionResults,
            setIsDisplayInitialRect,
            false,
            matchIds,
            setIsChemistryDataNotEnough,
            undefined,
            undefined,
            setLeaguevalues,
            setOverAllSystemFitScore
          );
          await fetchChemistrySummaryData(false, team, updatedSeasonId, matchIds, setLeaguevalues, startLoading, stopLoading);
        }
      }
    );
  };

  const handleZoomLevel3 = async (newZoomLevel: number, isPrevious: boolean, isNext: boolean, seasonId: number) => {
    const fetchData = async (updatedMatches: any[], updatedSeasonId: number) => {
      const matchIds = updatedMatches.map((match) => match.matchId);
      const newFormationId = await fetchFormationData(
        team,
        updatedSeasonId,
        startLoading,
        stopLoading,
        setFormationData,
        setSelectedFormation,
        matchIds
      );
      await fetchChemistryData(
        team,
        updatedSeasonId,
        setPositionResults,
        setTeamChemistry,
        startLoading,
        stopLoading,
        newFormationId!,
        setLastTeamChemistry,
        setLastPositionResults,
        setIsDisplayInitialRect,
        false,
        matchIds,
        setIsChemistryDataNotEnough,
        undefined,
        undefined,
        setLeaguevalues,
        setOverAllSystemFitScore
      );
      await fetchChemistrySummaryData(false, team, updatedSeasonId, matchIds, setLeaguevalues, startLoading, stopLoading);
    };
    await fetchMatchTimeline(
      startLoading,
      stopLoading,
      team,
      setMatches,
      setDisabledButtons,
      setSelectedSeasonId,
      seasonId,
      isPrevious,
      isNext,
      newZoomLevel,
      setTeamMatchesByMonth,
      setTimeLineTag,
      setSeasonName,
      false,
      fetchData
    );
  };

  const handleConfirm = async (selectedData: SelectedData) => {
    setIsSwapActive(false);
    setPlayerToSwap(0);
    setPlayerToSwapWith(0);
    setCurrentPlayerView(0);
    setOtherClubPlayer(0);
    setSwappedPlayerClub("");
    const { zoomLevelId, seasonId, selectedOption, matchId, overall } = selectedData;
    setZoomLevelId(zoomLevelId);
    setSelectedSeasonId(seasonId);
    setThirdOfSeason(selectedOption!!);
    if (overall) {
      await fetchOverallFormationData(team, setFormationData, setSelectedFormation);
      await fetchChemistryData(
        team,
        0,
        setPositionResults,
        setTeamChemistry,
        startLoading,
        stopLoading,
        0,
        setLastTeamChemistry,
        setLastPositionResults,
        setIsDisplayInitialRect,
        true,
        [],
        setIsChemistryDataNotEnough,
        undefined,
        undefined,
        setLeaguevalues,
        setOverAllSystemFitScore
      );
      await fetchChemistrySummaryData(true, team, 0, [], setLeaguevalues, startLoading, stopLoading);
      setMatches([]);
    } else {
      if (zoomLevelId === 2) fetchMatchTimelineZoom2(selectedData.selectedOption!!, false, false, 2, team, selectedData.seasonId);
      else if (zoomLevelId === 3) handleZoomLevel3(zoomLevelId, false, false, selectedData.seasonId);
    }
  };

  const handleFormationChange = async (formationId: number) => {
    setIsSwapActive(false);
    setPlayerToSwap(0);
    setPlayerToSwapWith(0);
    setCurrentPlayerView(0);
    setOtherClubPlayer(0);
    setSwappedPlayerClub("");
    if (team > 0 && formationId > 0) {
      setAlreadyPlottedPlayer({
        playerID: 0,
        xPosition: 0,
        yPosition: 0,
      });
      setIsSwapActive(false);
      setIsIndividualChemistry(false);
      const matchIds = matches.map((match) => match.matchId);
      await fetchChemistryData(
        team,
        selectedSeasonId,
        setPositionResults,
        setTeamChemistry,
        startLoading,
        stopLoading,
        formationId,
        setLastTeamChemistry,
        setLastPositionResults,
        setIsDisplayInitialRect,
        zoomLevelId === 4 ? true : false,
        matchIds,
        setIsChemistryDataNotEnough,
        undefined,
        undefined,
        setLeaguevalues,
        setOverAllSystemFitScore
      );
      await fetchChemistrySummaryData(
        zoomLevelId === 4 ? true : false,
        team,
        selectedSeasonId,
        matchIds,
        setLeaguevalues,
        startLoading,
        stopLoading
      );
    }
  };

  const handleIndividualChemistry = (playerID: number, positionCode: string) => {
    setAlreadyPlottedPlayer({
      playerID: 0,
      xPosition: 0,
      yPosition: 0,
    });
    setIsIndividualChemistry(true);
    setIsSwapActive(false);
    setLastTeamChemistry(teamChemistry);
    setLastPositionResults(positionResults);
    fetchIndividualChemistry(
      startLoading,
      stopLoading,
      playerID,
      positionCode,
      setPositionResults,
      setTeamChemistry,
      positionResults,
      selectedFormation,
      zoomLevelId === 4 ? true : false,
      team,
      selectedSeasonId,
      matches.map((match) => match.matchId)
    );
  };

  const handleReset = async () => {
    setIsIndividualChemistry(false);
    setAlreadyPlottedPlayer({
      playerID: 0,
      xPosition: 0,
      yPosition: 0,
    });
    setSwappedPositionResults([]);
    setSwappedTeamChemistry([]);
    setSelectedByPlayerPair("Skill")
    if (lastTeamChemistry.length > 0 && lastPositionResults.length > 0) {
      setPositionResults(lastPositionResults);
      setTeamChemistry(lastTeamChemistry);
      setLastTeamChemistry([]);
      setLastPositionResults([]);
    } else {
      try {
        setIsSwapActive(false);
        setPlayerToSwapWith(0);
        setCurrentPlayerView(0);
        const matchIds = matches.map((match) => match.matchId);
        if (zoomLevelId === 4) {
          await fetchOverallFormationData(team, setFormationData, setSelectedFormation);
        }
        await fetchChemistryData(
          team,
          selectedSeasonId,
          setPositionResults,
          setTeamChemistry,
          startLoading,
          stopLoading,
          selectedFormation,
          setLastTeamChemistry,
          setLastPositionResults,
          setIsDisplayInitialRect,
          zoomLevelId === 4 ? true : false,
          matchIds,
          setIsChemistryDataNotEnough,
          undefined,
          undefined,
          setLeaguevalues,
          setOverAllSystemFitScore
        );
        await fetchChemistrySummaryData(
          zoomLevelId === 4 ? true : false,
          team,
          selectedSeasonId,
          matchIds,
          setLeaguevalues,
          startLoading,
          stopLoading
        );
      } catch (error) {
        console.error("Error in handleReset:", error);
      }
    }
  };

  const getChemistrybetweenPlayers = async (player1: number, player2: number) => {
    await fetchPredictiveChemistryConnection(player1, player2, startLoading, stopLoading, setTeamChemistry, teamChemistry);
  };

  const getAllMissingChemistrys = async () => {
    const allMissingLinks = teamChemistry?.filter((connection) => connection.score === 0);
    startLoading();
    const promises = allMissingLinks.map(async (connection) => {
      return fetchPredictiveChemistryConnection(
        connection.player1,
        connection.player2,
        () => {},
        () => {},
        setTeamChemistry,
        teamChemistry
      );
    });
    await Promise.all(promises);
    if (isSwapActive) {
      const allMissingLinks = swappedTeamChemistry?.filter((connection) => connection.score === 0);
      startLoading();
      const promises = allMissingLinks.map(async (connection) => {
        return fetchPredictiveChemistryConnection(
          connection.player1,
          connection.player2,
          () => {},
          () => {},
          setSwappedTeamChemistry,
          swappedTeamChemistry
        );
      });
      await Promise.all(promises);
      stopLoading();
    } else {
      stopLoading();
    }
  };

  useEffect(() => {
    setSelectedByPlayerPair("Skill")
    const fetchData = async () => {
      if (team !== selectedTeam) {
        try {
          await fetchOverallFormationData(team, setFormationData, setSelectedFormation);
          await fetchChemistryData(
            team,
            0,
            setPositionResults,
            setTeamChemistry,
            startLoading,
            stopLoading,
            0,
            setLastTeamChemistry,
            setLastPositionResults,
            setIsDisplayInitialRect,
            true,
            [],
            setIsChemistryDataNotEnough,
            setFormationData,
            setSelectedFormation,
            setLeaguevalues,
            setOverAllSystemFitScore
          );
          await fetchChemistrySummaryData(true, team, 0, [], setLeaguevalues, startLoading, stopLoading);
          setMatches([]);
          setZoomLevelId(4);
          setIsSwapActive(false);
          setCurrentPlayerView(0);
          setSelectedTeam(team);
        } catch (error) {
          if (team > 0) {
            setPositionResults([]);
            setTeamChemistry([]);
            setFormationData([]);
            setSelectedFormation(0);
          }
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
  }, [team]);

  useEffect(() => {
    const fetchDataForTeam = async (teamId: number) => {
      startLoading();
      try {
        await Promise.all([fetchSeasonData(startLoading, stopLoading, teamId, setSeasonData)]);
      } catch (error) {
        console.error("Error fecthcing data from team:", error);
      } finally {
        stopLoading();
      }
    };
    if (timeLineDrawerOpen) {
      fetchDataForTeam(team);
    }
  }, [timeLineDrawerOpen]);

  useEffect(() => {
    if (isSwapActive) {
      setNewAvgAge(
        Number(
          (positionResults?.reduce((acc, curr) => acc + curr.age, 0) / positionResults.filter((player) => player.age > 0)?.length).toFixed(
            2
          )
        )
      );
      setNewAttackContribution(
        Math.trunc(
          positionResults?.reduce((acc, curr) => acc + curr.contributionValue, 0) /
            positionResults?.filter((player) => player?.playerId > 0)?.length
        )
      );
      setNewPPDA(Number(positionResults?.reduce((acc, curr) => acc + curr.ppda, 0).toFixed(2)));
    } else {
      setAvgAge(
        Number(
          (positionResults?.reduce((acc, curr) => acc + curr.age, 0) / positionResults.filter((player) => player.age > 0)?.length).toFixed(
            2
          )
        )
      );
      setAttackContribution(
        Math.trunc(
          positionResults?.reduce((acc, curr) => acc + curr.contributionValue, 0) /
            positionResults?.filter((player) => player?.playerId > 0)?.length
        )
      );
      setPPDA(Number(positionResults?.reduce((acc, curr) => acc + curr.ppda, 0).toFixed(2)));
    }
  }, [positionResults]);

  useEffect(() => {
    if (isSwapActive) {
      setNewOverallSFScore(
        Math.trunc(
          teamChemistry?.reduce((acc, curr) => acc + curr.score, 0) / teamChemistry?.filter((connection) => connection?.score > 0)?.length
        )
      );
    } else {
      setOverallSFScore(
        Math.trunc(
          teamChemistry?.reduce((acc, curr) => acc + curr.score, 0) / teamChemistry?.filter((connection) => connection?.score > 0)?.length
        )
      );
    }
  }, [teamChemistry]);

  const handleSwapPlayer = async (
    playerToSwapWith: number,
    playerToGoOut?: number,
    swapPosition?: string,
    secondSwapPlayer?: ChemistryPlayerPositions
  ) => {
    if (!secondSwapPlayer) {
      const playerAlready = positionResults.filter((player) => player.playerId === playerToSwapWith);
      if (playerAlready?.length === 1) {
        setAlreadyPlottedPlayer({
          playerID: playerAlready[0].playerId,
          xPosition: playerAlready[0].xCoordinate,
          yPosition: playerAlready[0].yCoordinate,
        });
      } else {
        setAlreadyPlottedPlayer({
          playerID: 0,
          xPosition: 0,
          yPosition: 0,
        });
      }
    }
    if (playerToSwapWith > 0 && selectedFormation > 0) {
      setIsSwapActive(true);
      setPlayerToSwapWith(playerToSwapWith);
      setCurrentPlayerView(playerToSwapWith);
      setIsIndividualChemistry(false);
      const positionResultsFromResponse = await fetchAfterSwapData(
        startLoading,
        stopLoading,
        playerToGoOut ? playerToGoOut : playerToSwap,
        playerToSwapWith,
        swapPosition ? swapPosition : swapPositionCode,
        selectedFormation,
        positionResults,
        teamChemistry,
        setPositionResults,
        setTeamChemistry,
        setSwappedPositionResults,
        setSwappedTeamChemistry,
        team,
        zoomLevelId === 4 ? true : false,
        selectedSeasonId,
        matches.map((match) => match.matchId),
        setOverAllSystemFitScore
      );
      if (positionResultsFromResponse?.length! > 1 && secondSwapPlayer) {
        const newPositionResults = await fetchAfterSwapData(
          startLoading,
          stopLoading,
          0,
          playerToGoOut ? playerToGoOut : playerToSwap,
          secondSwapPlayer?.positionCode!,
          selectedFormation,
          positionResultsFromResponse!,
          teamChemistry,
          setPositionResults,
          setTeamChemistry,
          setSwappedPositionResults,
          setSwappedTeamChemistry,
          team,
          zoomLevelId === 4 ? true : false,
          selectedSeasonId,
          matches.map((match) => match.matchId),
          setOverAllSystemFitScore
        );
        setPositionResults(newPositionResults!.filter((player) => player?.playerId !== 0));
        // setTeamChemistry(teamChemistry?.filter((connection) => connection?.score !== null));
      }
    }
    setSidebarPlayerShow(false);
  };

  useEffect(()=>{
      const filteredplayerPair = teamChemistry
      .filter((item) => item.isPredictive === true)
      .map((item) => ({
        playerId1: item.player1,
        playerId2: item.player2
      }));

      const fetchSynergyData = async  () => {
        startLoading();
        try {
          const ApiRequestData = {
            playerPair : filteredplayerPair
          }
          const response: IApiResponse<ISynergyData[]> = await postData(apiUrls.SynergyByPlayerPair, ApiRequestData);
          handleApiResponse(
            response,
            (synergyData) => {
              stopLoading();
              setSynergyData(synergyData);
            },
            (error) => {
              console.error(error);
              stopLoading();
            }
          );
        } catch (error) {
          console.error("Error fetching synergy data:", error);
          stopLoading();
        }
      }
      if(selectedByPlayerPair === 'style' && swappedPositionResults.length > 0 && swappedTeamChemistry.length > 0){
        fetchSynergyData();
      }
  },[selectedByPlayerPair,swappedPositionResults,swappedTeamChemistry])

  const handleSearchChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSearch(event, setSearchText, startLoading, setSearchData, stopLoading);
  };

  const handleClear = () => {
    setSearchText("");
    setSearchData?.([]);
  };

  const handleClose = () => {
    setSearchText("");
    setSearchData?.([]);
  };

  const handleSelect = (item: IPlayerSearchResponse | IPlayerSearchResponse[] | null, selected: boolean) => {
    if (Array.isArray(item) && item.length > 0) {
      handleSwapPlayer(item[0].playerId);
      setSwappedPlayerClub(item[0].playerClubURL);
      setOtherClubPlayer(item[0].playerId);
      handleClose();
    }
  };

  useEffect(() => {
    if (sidebarPlayerShow && team > 0) {
      setPlayerToSwap(swapHoverPlayer);
      fetchSwapablePlayerData(
        team,
        setPlayerFromSamePositions,
        setOtherSquadMembers,
        startLoading,
        stopLoading,
        swapHoverPlayer,
        swapPositionCode,
        setSwapHoverPlayer,
        selectedSeasonId
      );
    }
  }, [sidebarPlayerShow]);

  useEffect(() => {
    if (playerCardID > 0) {
      fetchPlayerCardData(startLoading, stopLoading, playerCardID, setPlayerCardDeatils);
    } else {
      setPlayerCardDeatils(undefined);
    }
  }, [playerCardID]);

  const getNewZoomLevel = (currentZoomLevel: 1 | 2 | 3 | 4, buttonKey: ButtonKey): 1 | 2 | 3 | 4 => {
    switch (buttonKey) {
      case "zoomIn":
        return currentZoomLevel === 4 ? 3 : currentZoomLevel === 3 ? 2 : currentZoomLevel === 2 ? 1 : currentZoomLevel;
      case "zoomOut":
        return currentZoomLevel === 3 ? 4 : currentZoomLevel === 1 ? 2 : currentZoomLevel === 2 ? 3 : currentZoomLevel;
      case "previous":
      case "next":
        return currentZoomLevel === 2 ? 2 : currentZoomLevel;
      default:
        return currentZoomLevel;
    }
  };

  const handleZoomLevel2 = async (newZoomLevel: number, isPrevious: boolean, isNext: boolean) => {
    let newThirdOfSeason = thirdOfSeason;
    if (isPrevious) {
      newThirdOfSeason = thirdOfSeason === "FinalThird" ? "MiddleThird" : thirdOfSeason === "MiddleThird" ? "FirstThird" : thirdOfSeason;
    } else if (isNext) {
      newThirdOfSeason = thirdOfSeason === "FirstThird" ? "MiddleThird" : thirdOfSeason === "MiddleThird" ? "FinalThird" : thirdOfSeason;
    }
    setThirdOfSeason(newThirdOfSeason);
    await fetchMatchTimelineZoom2(newThirdOfSeason, isPrevious, isNext, newZoomLevel, team);
  };

  const toggleButtonState = async (buttonKey: ButtonKey) => {
    setIsSwapActive(false);
    setPlayerToSwap(0);
    setPlayerToSwapWith(0);
    setCurrentPlayerView(0);
    setOtherClubPlayer(0);
    setSwappedPlayerClub("");
    const newZoomLevel = getNewZoomLevel(zoomLevelId, buttonKey);
    switch (newZoomLevel) {
      case 4:
        await fetchOverallFormationData(team, setFormationData, setSelectedFormation);
        await fetchChemistryData(
          team,
          0,
          setPositionResults,
          setTeamChemistry,
          startLoading,
          stopLoading,
          0,
          setLastTeamChemistry,
          setLastPositionResults,
          setIsDisplayInitialRect,
          true,
          [],
          setIsChemistryDataNotEnough,
          setFormationData,
          setSelectedFormation,
          setLeaguevalues
        );
        await fetchChemistrySummaryData(true, team, 0, [], setLeaguevalues, startLoading, stopLoading);
        setMatches([]);
        setZoomLevelId(newZoomLevel);
        setDisabledButtons((prevState) => ({
          ...prevState,
          play: true,
          previous: true,
          next: true,
          zoomIn: false,
          zoomOut: true,
        }));
        break;
      case 3:
        await handleZoomLevel3(newZoomLevel, buttonKey === "previous", buttonKey === "next", selectedSeasonId);
        setZoomLevelId(newZoomLevel);
        break;
      case 2:
        await handleZoomLevel2(newZoomLevel, buttonKey === "previous", buttonKey === "next");
        setZoomLevelId(newZoomLevel);
        break;
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (playerCardRef.current) {
      // @ts-ignore
      if (!playerCardRef.current?.contains(event.target)) {
        setPlayerCardDeatils(undefined);
        setPlayerCardID(0);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMouseEnter = (
    setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>,
    timeoutRef: React.MutableRefObject<NodeJS.Timeout | null>
  ) => {
    timeoutRef.current = setTimeout(() => {
      setShowTooltip(true);
    }, 500);
  };

  const handleMouseLeave = (
    setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>,
    timeoutRef: React.MutableRefObject<NodeJS.Timeout | null>
  ) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShowTooltip(false);
  };

  const handlePPDATolltipShow = () => {
    PPDATooltipRef.current = setTimeout(() => {
      setIsPPDATooltipOpen(true);
    }, 500);
  };

  const handlePPDATolltipHide = () => {
    if (PPDATooltipRef.current) {
      clearTimeout(PPDATooltipRef.current);
    }
    setIsPPDATooltipOpen(false);
  };

  useEffect(() => {
    setIsSystemfitLoading(true);
    const intervalId = setInterval(() => {
      setLoadingProgressValue((prev) => {
        if (prev >= 75) {
          clearInterval(intervalId);
          return prev;
        }
        return prev + 25;
      });
      setSubProcessIndex((prev) => {
        if (prev < 3) {
          return prev + 1;
        } else {
          return 3;
        }
      });
    }, 1000);
    setTimeout(() => setIsSystemfitLoading(false), 3000);
    return () => clearInterval(intervalId);
  }, [team]);

  useEffect(() => {
    if (positionResults?.length === 0) {
      setIsSystemfitLoading(true);
      const intervalId = setInterval(() => {
        setLoadingProgressValue((prev) => {
          if (prev >= 75) {
            clearInterval(intervalId);
            return prev;
          }
          return prev + 25;
        });
        setSubProcessIndex((prev) => {
          if (prev < 3) {
            return prev + 1;
          } else {
            return 3;
          }
        });
      }, 3000);
      return () => clearInterval(intervalId);
    } else {
      setSubProcessIndex(3);
      setLoadingProgressValue(100);
      setTimeout(() => setIsSystemfitLoading(false), 1000);
    }
  }, [positionResults]);

  const handleLoadAnyway  = async () => {
    await fetchChemistryData(
      team,
      selectedSeasonId,
      setPositionResults,
      setTeamChemistry,
      startLoading,
      stopLoading,
      selectedFormation,
      setLastTeamChemistry,
      setLastPositionResults,
      setIsDisplayInitialRect,
      zoomLevelId === 4,
      matches.map((match) => match.matchId),
      setIsChemistryDataNotEnough,
      setFormationData,
      setSelectedFormation,
      setLeaguevalues,
      setOverAllSystemFitScore,
      true,
    );
  }

  return (
    <>
      <div className="common-squad-systemfit" style={{paddingTop : isFromClub ? '0px' : '48px'}}>
        <StyledHeader className="header-content">
          <div className="chart-bottom-container">
            <LabelText className="player-family-name">System fit</LabelText>
          </div>
          <div className="squad-team-selection">
            <LabelText className="team-selection-text">SHOWING:</LabelText>
            <CustomButton
              color="primary"
              endIcon={<KeyboardArrowDownIcon />}
              onClick={() => {
                setTimeLineDrawerOpen(true);
              }}
            >
              <LabelText className="player-search-text">{zoomLevelId === 4 ? "Overall" : timeLineTag}</LabelText>
            </CustomButton>
            <LabelNumber className="season-text"> {zoomLevelId !== 4 && `• ${seasonName}`}</LabelNumber>
          </div>
          <div className="squad-timeline-navigation">
            <div
              onMouseEnter={() => handleMouseEnter(setShowLeftTooltip, leftTooltipTimeout)}
              onMouseLeave={() => handleMouseLeave(setShowLeftTooltip, leftTooltipTimeout)}
            >
              <SecondaryButton
                iconType="keyboardarrowleft"
                disabled={disabledButtons.previous}
                onClick={() => toggleButtonState("previous")}
              />
              {zoomLevelId !== 4 && showLeftTooltip && (
                <span className="left-tooltiptext tooltiptext">
                  {zoomLevelId === 2 ? "Previous 3rd of a season" : zoomLevelId === 3 ? "Previous season" : ""}
                </span>
              )}
            </div>
            <div
              onMouseEnter={() => handleMouseEnter(setShowRightTooltip, rightTooltipTimeout)}
              onMouseLeave={() => handleMouseLeave(setShowRightTooltip, rightTooltipTimeout)}
            >
              <SecondaryButton iconType="keyboardarrowright" disabled={disabledButtons.next} onClick={() => toggleButtonState("next")} />
              {zoomLevelId !== 4 && showRightTooltip && (
                <span className="right-tooltiptext tooltiptext">
                  {zoomLevelId === 2 ? "Next 3rd of a season" : zoomLevelId === 3 ? "Next season" : ""}
                </span>
              )}
            </div>
          </div>
        </StyledHeader>
        <div className="squad-chemistry-parent">
          {isSwapActive && alreadyPlottedPlayer.playerID === 0 && swappedPlayerClub?.length! > 0 && swappedPositionResults.length > 1 && (
            <BothPlayerImageContainer className="pw-compare-container">
              <div className="image-container">
                <div className="module-chemistry-player-image">
                  <PlayerImageContainer isSelected={currentPlayerView === playerToSwap}>
                    <img
                      src={swappedPositionResults.find((player) => player.playerId === playerToSwap)?.playerImageURL}
                      alt=""
                      onClick={() => setCurrentPlayerView(playerToSwap)}
                    />
                  </PlayerImageContainer>
                  <img src={clubImg} alt="" className="module-chemistry-club-image" />
                </div>
                <div className="module-chemistry-player-image">
                  <PlayerImageContainer isSelected={currentPlayerView === playerToSwapWith}>
                    <img
                      src={positionResults.find((player) => player.playerId === playerToSwapWith)?.playerImageURL}
                      alt=""
                      onClick={() => setCurrentPlayerView(playerToSwapWith)}
                    />
                  </PlayerImageContainer>
                  <img src={swappedPlayerClub} alt="" className="module-chemistry-club-image" />
                </div>
              </div>
            </BothPlayerImageContainer>
          )}
          <div className="squad-chemistry-formation-container">
            <div className="pitch-formation">
              <>
                <LabelText className="team-selection-text">FORMATION:</LabelText>
                <CustomButton
                  endIcon={<KeyboardArrowDownIcon />}
                  color="primary"
                  onClick={() => {
                    setSidebarFormationOpen(!sidebarFormationOpen);
                  }}
                >
                  <LabelText className="player-given-name">
                    {formationData.find((form) => form.id === selectedFormation)?.formation}
                  </LabelText>
                </CustomButton>
              </>
            </div>
            <div className="pitch-performance">
              <>
                <LabelText className="player-given-name">Attack Contribution</LabelText>
                <Switch
                  id="player-switch"
                  toggled={isPerformancSwitchToggled}
                  onChange={handleSwitchClick}
                  source="Filter"
                  isByComparison={false}
                />
              </>
            </div>
          </div>
          <div className="squad-pitch-parent">
            <div className="back-chemistry-btn">
              { 
              // environment !== "production" && 
              isSwapActive && swappedPositionResults.length > 0 && swappedTeamChemistry.length > 0 && 
                <div className="skill-style-toggle-container">
                    <div className="toggle-content">
                        <LabelNumber className="toggle-style-text">Measured by:</LabelNumber>
                        <LabelNumber className={selectedByPlayerPair === "style" ? 'toggle-style-text' : 'percentile-text'} >Skill</LabelNumber>
                                    <Switch
                                      id="attribute-position"
                                      toggled={selectedByPlayerPair === "style"}
                                      onChange={() => setSelectedByPlayerPair?.(selectedByPlayerPair === "style" ? "skill" : "style")}
                                      source="Filter"
                                      type='attributes'
                                    />
                                    <LabelNumber className={selectedByPlayerPair === "skill" ? 'toggle-style-text' : 'percentile-text'}>Style</LabelNumber>
                    </div>
                    
                </div>
              } 
              {isSwapActive && (
                <BackToTeamChemistryBtn onClick={() => handleReset()}>
                  <img src={ResetIcon} alt="reset icon" />
                  Reset team
                </BackToTeamChemistryBtn>
              )}
              {isIndividualChemistry && (
                <BackToTeamChemistryBtn onClick={() => handleReset()}>
                  <KeyboardArrowLeftIcon />
                  Team network
                </BackToTeamChemistryBtn>
              )}
              {(teamChemistry?.some((connection) => connection.score === 0) ||
                (isSwapActive && swappedTeamChemistry?.some((connection) => connection.score === 0))) && (
                <BackToTeamChemistryBtn onClick={() => getAllMissingChemistrys()}>
                  <img src={Simulate} alt="simulate icon" />
                  Predict missing scores
                </BackToTeamChemistryBtn>
              )}
            </div>
            <div className="squad-pitch-container">
            <div className="squad-summary-bar-container">
              <div className="squad-summarybar-container">
                <div className="squad-chemistry-box">
                  OVERALL SYSTEM FIT SCORE
                  <span>
                    {/* {loading ? "--" : isSwapActive ? newOverallSFScore : overallSFScore}{" "}
                    {isSwapActive && !loading && newOverallSFScore !== overallSFScore && (
                      <span className={newOverallSFScore - overallSFScore > 0 ? "positive-difference" : "negative-difference"}>
                        <img src={newOverallSFScore - overallSFScore > 0 ? PositiveArrow : NegativeArrow} alt="" />
                        {newOverallSFScore - overallSFScore > 0 ? newOverallSFScore - overallSFScore : overallSFScore - newOverallSFScore}
                      </span>
                    )} */}
                    {loading ? "--" : overallSystemFitScore}
                  </span>
                </div>
                <div className="squad-chemistry-box">
                  OVERALL ATTACK CONTRIBUTION
                  <span>
                    {loading ? "--" : isSwapActive ? newAttackContribution : attackContribution}{" "}
                    {isSwapActive && !loading && newAttackContribution !== attackContribution && (
                      <span className={newAttackContribution - attackContribution > 0 ? "positive-difference" : "negative-difference"}>
                        <img src={newAttackContribution - attackContribution > 0 ? PositiveArrow : NegativeArrow} alt="" />
                        {newAttackContribution - attackContribution > 0
                          ? newAttackContribution - attackContribution
                          : attackContribution - newAttackContribution}
                      </span>
                    )}
                  </span>
                </div>
                <div className="squad-chemistry-box">
                  PPDA
                  {!loading && (
                    <div className="tooltip-icon-container">
                      <InfoOutlined onMouseEnter={handlePPDATolltipShow} onMouseLeave={handlePPDATolltipHide} />
                      {isPPDATolltipOpen && (
                        <div
                          className={`${
                            (newPPDA - ppda > 0 || ppda - newPPDA > 0) && isSwapActive ? "ppda-tooltip-swap-active" : "ppda-tooltip "
                          }`}
                        >
                          Passes Per Defensive Action (PPDA) is a stat used to gauge pressing intensity. <br /> The lower the score the
                          better
                        </div>
                      )}
                    </div>
                  )}
                  <span>
                    {loading ? "--" : isSwapActive ? newPPDA : ppda}{" "}
                    {isSwapActive && !loading && newPPDA !== ppda && (
                      <span className={newPPDA - ppda > 0 ? "negative-difference" : "positive-difference"}>
                        <img src={newPPDA - ppda > 0 ? NegativeArrow : PositiveArrow} alt="" className="inverted-arrow" />
                        {newPPDA - ppda > 0 ? (newPPDA - ppda).toFixed(2) : (ppda - newPPDA).toFixed(2)}
                      </span>
                    )}
                  </span>
                </div>
                <div className="squad-chemistry-box">
                  AV. AGE
                  <span>
                    {loading ? "--" : isSwapActive ? newAvgAge : avgAge}{" "}
                    {isSwapActive && !loading && newAvgAge !== avgAge && (
                      <span className={newAvgAge - avgAge > 0 ? "negative-difference" : "positive-difference"}>
                        <img src={newAvgAge - avgAge > 0 ? NegativeArrow : PositiveArrow} alt="" className="inverted-arrow" />
                        {newAvgAge - avgAge > 0 ? (newAvgAge - avgAge).toFixed(2) : (avgAge - newAvgAge).toFixed(2)}
                      </span>
                    )}
                  </span>
                </div>
                {/* <div className="squad-chemistry-box">
                    <div>
                       <div style={{display:'flex',gap:'5px',position:'absolute'}}>
                                  MANAGER
                                  {leagueValues?.coaches?.length! > 1 && (
                                    <CustomizedTooltips title={nationalityTooltip}>
                                        <img src={Plus} alt="plus-icon" style={{marginTop:'3px'}}/>
                                    </CustomizedTooltips>
                                  )}
                              </div>
                    </div>
                    <span>
                      {loading ? "--" : leagueValues?.coaches[0]?.coachName! || 0}{" "}
                    </span>
                </div>     */}
              </div>
              <div className="squad-league-detail-container">
                <div className="squad-league-position">
                  LEAGUE POSITION
                  <span>{loading || !leagueValues?.leaguePosition ? "--" : leagueValues?.leaguePosition}</span>
                </div>
                <div className="squad-win-loss-container">
                  <div className="squad-win-loss-box">
                    GOALS
                    <span>{loading || !leagueValues?.totalGoals ? "--" : leagueValues?.totalGoals}</span>
                  </div>
                  <div className="squad-win-loss-box">
                    G/A
                    <span>{loading || !leagueValues?.totalGoalsAgainst ? "--" : leagueValues?.totalGoalsAgainst}</span>
                  </div>
                  <div className="squad-win-loss-box">
                    XG
                    <span>{loading || !leagueValues?.xGoals ? "--" : leagueValues?.xGoals}</span>
                  </div>
                  <div className="squad-win-loss-box">
                    XG/A
                    <span>{loading || !leagueValues?.xGoalAgainst ? "--" : leagueValues?.xGoalAgainst}</span>
                  </div>
                </div>
              </div>
            </div>
              <Pitch
                currentView={"systemFit"}
                selectedTeam={team}
                setSidebarPlayerShow={setSidebarPlayerShow}
                isPerformancSwitchToggled={isPerformancSwitchToggled}
                positionResults={
                  currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? positionResults : swappedPositionResults
                }
                teamChemistry={currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? teamChemistry : swappedTeamChemistry}
                setSwapHoverPlayer={setSwapHoverPlayer}
                setSwapPositionCode={setSwapPositionCode}
                setIsReplacePlayer={setIsReplacePlayer}
                handleIndividualChemistry={handleIndividualChemistry}
                isIndividualChemistry={isIndividualChemistry}
                handleReset={handleReset}
                setIsIndividualChemistry={setIsIndividualChemistry}
                swappedPlayerClub={swappedPlayerClub}
                otherClubPlayer={otherClubPlayer}
                alreadyPlottedPlayer={alreadyPlottedPlayer}
                setPlayerCardID={setPlayerCardID}
                isDisplayInitialRect={isDisplayInitialRect}
                getChemistrybetweenPlayers={getChemistrybetweenPlayers}
                formationName={formationData.find((form) => form.id === selectedFormation)?.formation}
                isChemistryDataNotEnough={isChemistryDataNotEnough}
                playerCardID={playerCardID}
                handleSwapPlayer={handleSwapPlayer}
                isSystemfitLoading={isSystemfitLoading}
                selectedByPlayerPair={selectedByPlayerPair}
                synergyData={synergyData}
              />
              {isChemistryDataNotEnough && !isSystemfitLoading && (
                <div className="not-enough-data-container">
                  <img src={TrackerIcon} alt="tracker-icon" />
                  <p>Not enough season data for accurate scores yet</p>
                  <button onClick={() => handleLoadAnyway()}>Show scores anyway</button>
                </div>
              )}
              {isSystemfitLoading && (
                <div className="systemfit-loader">
                  <div className="loader-header-container">
                    <p>Creating System Fit</p>
                    <img src={MachineFootballIcon} className="mf-logo" alt="machine-football-logo" />
                  </div>
                  <div className="loader-progressbar-container">
                    <BorderLinearProgress variant="determinate" value={loadingProgressValue} />
                  </div>
                  <div className="loader-subprocess">
                    {subProcesses[subProcessIndex]}
                    <p>{loadingProgressValue}%</p>
                  </div>
                </div>
              )}
              {loading && !isSystemfitLoading && <ModuleSpinner />}
            </div>
            {playerCardID > 0 && playerCardDetails?.playerId! > 0 && (
              <div className="squad-pitch-player-card" ref={playerCardRef}>
                <PlayerLandingCard
                  key={playerCardDetails?.playerId!}
                  playerId={playerCardDetails?.playerId!}
                  givenName={playerCardDetails?.givenName!}
                  familyname={playerCardDetails?.familyname!}
                  playerImageURL={playerCardDetails?.playerImageURL!}
                  isInjured={playerCardDetails?.isInjured!}
                  onLoan={playerCardDetails?.onLoan!}
                  primaryPlayingPosition={playerCardDetails?.primaryPlayingPosition!}
                  age={playerCardDetails?.age!}
                  heightInCM={playerCardDetails?.heightInCM!}
                  playerAttributesByPosition={playerCardDetails?.playerAttributesByPosition!}
                  contributionValue={playerCardDetails?.contributionValue!}
                  performanceValue={playerCardDetails?.performanceValue!}
                  setPlayerCardDeatils={setPlayerCardDeatils}
                  setPlayerCardID={setPlayerCardID}
                  isPlayerInShortlist={playerCardDetails?.isPlayerInShortlist!}
                  isEasternPlayer={playerCardDetails?.isEasternPlayer!}
                  playerLabel={playerCardDetails?.playerLabel!}
                  archetypeName={playerCardDetails?.archetypeName!}
                  archetypeId={playerCardDetails?.archetypeId!}
                />
              </div>
            )}
          </div>
        </div>
        <Timeline
          isOpen={timeLineDrawerOpen}
          onClose={() => setTimeLineDrawerOpen(false)}
          teamId={team}
          seasonData={seasonData}
          teamMatchByMonthsData={teamMatchesByMonth}
          onConfirm={handleConfirm}
          zoomLevelId={zoomLevelId}
          selectedSeasonId={selectedSeasonId}
          isHideMatchOptions={true}
        />
        <FormationSelectDrawer
          sidebarFormationOpen={sidebarFormationOpen}
          setSidebarFormationOpen={setSidebarFormationOpen}
          formationData={formationData}
          selectedFormation={selectedFormation}
          setSelectedFormation={setSelectedFormation}
          handleFormationChange={handleFormationChange}
        />
        <PlayerSelectDrawer
          sidebarPlayerShow={sidebarPlayerShow}
          setSidebarPlayerShow={setSidebarPlayerShow}
          isReplacePlayer={isReplacePlayer}
          setIsReplacePlayer={setIsReplacePlayer}
          playerFromSamePositions={playerFromSamePositions}
          substitutePlayerOptions={[]}
          handleSwapPlayer={handleSwapPlayer}
          otherSquadMembers={otherSquadMembers}
          currentView={"systemFit"}
          handleSearchChange={handleSearchChange}
          handleClear={handleClear}
          searchText={searchText}
          searchData={searchData}
          handleSelect={handleSelect}
        />
      </div>
      {displayCardNotification && (
        <PWNotification
          message={cardNotificationContent}
          setIsNotification={() => seIsDisplayCardNotification(false)}
          isDisplayCloseIcon={true}
          className="player-filter-notification add-similar-notification"
        />
      )}
    </>
  );
});
